module.exports = __webpack_public_path__ + "static/empty-states-value-props-sample-content-do-9a05baad9ffaf618033ce088601ee341.png";